module.exports = __webpack_public_path__ + "static/img/carbonMonitor.62d52adb.png";